import clsx from 'clsx';

interface FusePageSimpleHeaderProps {
	className?: string;
	header?: React.ReactNode;
}

function FusePageSimpleHeader(props: FusePageSimpleHeaderProps) {
	return (
		<div className={clsx('FusePageSimple-header', props.className)}>
			<div className="container">{props.header && props.header}</div>
		</div>
	);
}

export default FusePageSimpleHeader;
